import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

import { LOCAL_COLORS } from 'styles/constants';

export const Title = styled.h1`
  font-family: var(--base-font);
  font-weight: ${({ theme }) => theme.TYPOGRAPHY.fontWeight.bold};
  font-size: 2.5rem;
  line-height: 110%;
  max-width: 800px;
  color: ${LOCAL_COLORS.surfaceWhite};
  margin-bottom: ${SPACER.small};

  ${MEDIA_QUERIES.smUp} {
    color: ${LOCAL_COLORS.surfaceDarkBold};
  }

  ${MEDIA_QUERIES.xlUp} {
    font-family: var(--header-font);
    font-size: 6rem;
    line-height: 100%;
  }
`;

export const Subtitle = styled.p`
  font-family: var(--base-font);
  font-weight: ${({ theme }) => theme.TYPOGRAPHY.fontWeight.bold};
  line-height: 132%;
  letter-spacing: -0.02;
  color: ${LOCAL_COLORS.surfaceWhite};
  width: 88%;
  margin-bottom: ${SPACER.base};

  ${MEDIA_QUERIES.smUp} {
    color: ${LOCAL_COLORS.surfaceDarkBold};
  }

  ${MEDIA_QUERIES.xlUp} {
    font-size: 2rem;
    line-height: 110%;
  }
`;

export const EfficacyStat = styled.p`
  background-color: ${LOCAL_COLORS.surfaceOrange};
  color: ${LOCAL_COLORS.surfaceDarkBold};
  padding: ${SPACER.xsmall};
  width: max-content;
  margin: ${SPACER.small} 0;
  font-weight: 700;
  font-size: ${({ theme }) => theme.TYPOGRAPHY.fontSize.label};
  line-height: 140%;

  ${MEDIA_QUERIES.xlUp} {
    padding: ${SPACER.small} ${SPACER.base};
    margin: 0.75rem 0;
    font-size: ${({ theme }) => theme.TYPOGRAPHY.fontSize.body};
  }
`;

export const MainContainer = styled.section`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  background: linear-gradient(90deg, #f3f0e4 0%, #e9e7da 100%);
  position: relative;

  padding-top: ${SPACER.large};
  ${MEDIA_QUERIES.mdUp} {
    padding-top: 0;
  }
`;

export const LeftBox = styled.div`
  background-color: ${LOCAL_COLORS.surfaceDarkBold};
  flex-grow: 1;
  flex-basis: 0;
  height: 153px;
`;

export const RightBox = styled.div`
  background-color: ${LOCAL_COLORS.surfaceDarkBold};
  flex-grow: 1;
  flex-basis: 0;
  height: 115px;
`;

export const InnerContainer = styled.div`
  position: relative;
`;

export const ContentContainer = styled.div`
  background-color: ${LOCAL_COLORS.surfaceDarkBold};
  padding: 0 ${SPACER.base} ${SPACER.x3large};

  ${MEDIA_QUERIES.smUp} {
    background-color: transparent;
    width: 60%;
    position: absolute;
    top: 16%;
    left: 4%;
  }
`;

export const ImageContainer = styled.div<{ backgroundColor: string }>`
  ${({ backgroundColor }) => `background-color: ${backgroundColor};`};
`;

export const darkBoldBackgroundStyles = css`
  background-color: ${LOCAL_COLORS.surfaceDarkBold};

  // hide 1px border at top of hero image because of transparency
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(29, 29, 68, 1) 10%,
    rgba(29, 29, 68, 1) 100%
  );
`;

export const ProdBanner = styled.div`
  display: flex;
  justify-content: center;
  line-height: 1.67;
  text-align: center;
  background: #ff824f;
  padding: 0.75rem 0;
  text-transform: initial;
  letter-spacing: initial;
  font-weight: bold;
  color: #332e54;
  width: 100%;
  font-size: 0.8rem;
  gap: 0.5rem;
  position: fixed;
  top: 62px;
  z-index: 999;

  ${MEDIA_QUERIES.xlUp} {
    font-size: 0.875rem;
    top: 74px;
  }

  svg {
    position: relative;
    top: 0.15rem;
  }
`;

export const ctaStyles = css`
  padding-top: ${SPACER.medium};
  max-width: 225px;
  margin: 0;
`;
